// Practical results types matching common_tools.py
export const practicalResults: readonly string[] = [
  // "Research Report",
  // "Project",
  "Software",
  "Prototype",
  "Industrial Design",
  "Functional Sample",
  // "Results Reflected in the Directives and Non-legislative Regulations",
  // "Approved Methodology (for RIV)",
  "Utility Model",
  "Verified Technology",
  "Certified Methodology (for RIV)",
  "Patent",
  // "Result Reflected in Legislation and Standards",
  // "Technical Report",
  // "Specialized Map with Expert Content",
  // "Electronic Document with Local Access (CD)",
  // "Specialized public database (for RIV)",
  // "Other Methodology (not meeting RIV conditions)",
  // "Utility Model Application",
  // "Patent Application",
  // "Electronic Document with Remote Access (www)",
  // "Pilot Plant",
  // "Audiovisual Work",
  // "Preservation Procedure",
  "Unpatented Invention (Know-how)",
  "Other Software (not meeting RIV conditions)",
  "Technical Work",
  // "Other Legal Enactments (not meeting RIV conditions)",
  // "Other Map (not meeting RIV conditions)",
  // "Industrial Design Application"
];

export const isPracticalType = (type: string): boolean => {
  return practicalResults.includes(type);
};
